/**
 * This is a store that hold the dark mode state
 * It could be auto (fit system preference), dark or light
 *
 * Using useStorage from @vueuse/core allow persistance storage accross tabs/sessions
 *
 * We can import and set isDark anywhere in our project
 * @see /src/components/navigation/LandingNavigation.vue
 * @see /src/components/partials/toolbars/Toolbar.vue
 */

import {computed} from 'vue'
import {useStorage} from '@vueuse/core'
export type TagsStyle =
  // 下拉框模式
  | 'select'
  // flex排布模式
  | 'flex'

export const hideDeletedContentsSchema = useStorage<boolean>('hideDeletedContents', true)
export const hideDeletedContents = computed({
  get() {
    return hideDeletedContentsSchema.value
  },
  set(v: boolean) {
    hideDeletedContentsSchema.value = v
  },
})

export const formTagsStyleSchema = useStorage<TagsStyle>('formTagsStyle', 'flex')
export const formTagsStyle = computed({
  get() {
    return formTagsStyleSchema.value
  },
  set(v: TagsStyle) {
    formTagsStyleSchema.value = v
  },
})

export const mallStatisticsSwitchSchema = useStorage<boolean>('mallStatisticsSwitch', true)
export const mallStatisticsSwitch = computed({
  get() {
    return mallStatisticsSwitchSchema.value
  },
  set(v: boolean) {
    mallStatisticsSwitchSchema.value = v
  },
})

